import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import InputSelect from '@components/InputSelect';
import InputText from '@components/InputText';
import type { Step } from '@features/create-entity-modal/types';
import type { Team } from '@root/@types/types';

import type { StepProps } from '../types';

interface Step1Props extends StepProps {
  currentStep: Step;
  userTeams: Team[];
}

const getRequiredMessage = (message: string = '') => {
  return message === 'Required' ? 'A contract requires a name' : message;
};

export const Step1: FC<Step1Props> = ({ control, userTeams }) => {
  return (
    <div className="flex flex-col gap-6">
      <Controller
        control={control}
        render={({ field, fieldState: { error } }) => (
          <InputText
            {...field}
            errors={getRequiredMessage(error?.message)}
            isDisabled
            readOnly
            labelText="Contract name"
            placeholder="New Contract"
          />
        )}
        name="name"
      />
      <Controller
        control={control}
        render={({ field, fieldState: { error } }) => (
          <InputSelect
            {...field}
            data-testid="select:assign-to-team"
            errors={error?.message}
            isDisabled
            onChange={(value) => field.onChange([value])}
            labelText="Contract team"
            options={userTeams.map(({ id, name }) => ({ name, value: id }))}
            value={field.value?.[0]}
          />
        )}
        name="team"
      />
    </div>
  );
};
